import type { FC } from 'react';

export type CategoryPageLoadingFallbackProps = {};

/**
 * Loading fallback displayed while search result is still not available
 * */
export const CategoryPageLoadingFallback: FC<CategoryPageLoadingFallbackProps> = () => null;
